export const CREATE_HITO_SUBTIPO = `
  mutation createHitoSubtipo($input: CreateHitoSubtipoInput!, $tenant_id: Int!) {
    createHitoSubtipo(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on HitoSubtipo {
        id
        hito_tipo_id
        name
        active
        vistage20_id
        hito_tipo {
          id
          name
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_HITO_SUBTIPO = `
  mutation updateHitoSubtipo($input: UpdateHitoSubtipoInput!, $tenant_id: Int!) {
    updateHitoSubtipo(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on HitoSubtipo {
        id
        hito_tipo_id
        name
        active
        vistage20_id
        hito_tipo {
          id
          name
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_HITO_SUBTIPO = `
  mutation deleteHitoSubtipo($id: Int!, $tenant_id: Int!) {
    deleteHitoSubtipo(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on HitoSubtipo {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
